export default __webpack_public_path__ + "static/media/702.7fe0c6c1.gif";